import { useCallback } from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import { quoteConfirmationState, quoteItemState } from "@/store";
import { printHouseProfile } from "@/store/print-house-profile";
import { applyOptimisticTaxCalculating } from "@/widgets/quote-new/utils/quickbooks-tax-ui";

/**
 * Sets taxCalculating on the document in Recoil before ERP requests,
 * so the tax loader appears immediately for QuickBooks print houses.
 */
export const useStartOptimisticQuickBooksTax = (options?: {
  isQuoteConfirmation?: boolean;
  syncQuoteItems?: (document: any) => void;
}) => {
  const printHouseProfileState = useRecoilValue(printHouseProfile);
  const [, setQuoteItemValue] = useRecoilState<any>(quoteItemState);
  const [, setQuoteConfirm] = useRecoilState<any>(quoteConfirmationState);

  const startOptimisticTaxCalculation = useCallback(() => {
    const erpType = printHouseProfileState?.erpType;
    const updater = (prev: any) =>
      applyOptimisticTaxCalculating(prev, erpType) ?? prev;

    if (options?.isQuoteConfirmation) {
      setQuoteConfirm(updater);
    } else {
      setQuoteItemValue(updater);
    }

    if (options?.syncQuoteItems) {
      options.syncQuoteItems((prev: any) => updater(prev));
    }
  }, [
    options?.isQuoteConfirmation,
    options?.syncQuoteItems,
    printHouseProfileState?.erpType,
    setQuoteConfirm,
    setQuoteItemValue,
  ]);

  return { startOptimisticTaxCalculation };
};
